module.exports = {"TXTCLI_Invalid_date":{"id":"TXTCLI_Invalid_date","defaultMessage":"無効な日付","track":"Invalid date"}}